import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  useEffect(() => {
    let cancelled = false;
    api.get("/audit")
      .then((r) => { if (!cancelled) setLogs(r.data); })
      .catch(() => { /* audit log reloads on next mount */ });
    return () => { cancelled = true; };
  }, []);
  return (
    <div className="fade-in-up">
      <div className="mb-8"><div className="text-caption text-[#B91C1C] mb-2">AUDIT</div><h1 className="font-serif text-3xl font-bold text-[#0A192F]">Comprehensive Audit Log</h1></div>
      <div className="card-federal">
        <table className="w-full text-sm">
          <thead className="bg-slate-50"><tr>
            <th className="text-left px-6 py-3 text-caption">When</th>
            <th className="text-left px-6 py-3 text-caption">User</th>
            <th className="text-left px-6 py-3 text-caption">Action</th>
            <th className="text-left px-6 py-3 text-caption">Resource</th>
            <th className="text-left px-6 py-3 text-caption">Meta</th>
          </tr></thead>
          <tbody>
            {logs.length === 0 && <tr><td colSpan={5} className="text-center py-8 text-slate-500">No audit events yet.</td></tr>}
            {logs.map((l) => (
              <tr key={l.id} className="border-t border-slate-100" data-testid={`audit-${l.id}`}>
                <td className="px-6 py-3 font-mono text-xs">{l.created_at?.slice(0,19)}</td>
                <td className="px-6 py-3 font-mono text-xs">{l.user_id?.slice(0,8)}…</td>
                <td className="px-6 py-3"><span className="badge-federal">{l.action}</span></td>
                <td className="px-6 py-3 text-slate-700">{l.resource} <span className="text-slate-400 font-mono text-xs">{l.resource_id?.slice(0,8)}</span></td>
                <td className="px-6 py-3 font-mono text-xs text-slate-500 max-w-[300px] truncate">{JSON.stringify(l.meta)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
